export default __webpack_public_path__ + "static/beach_hollywood-157aefdbe58ab0fafb873c3eb7e01500.png";